import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

export default function ArchiveSolid({ theme, ...props }) {
  return (
    <svg
      aria-labelledby={props.ariaTags.labelledBy}
      aria-hidden={props.ariaTags.hidden}
      className={cx(theme.container, theme[props.svg], props.className)}
      shapeRendering="geometricPrecision"
      tabIndex={props.tabIndex}
      vectorEffect="non-scaling-stroke"
      viewBox="-4 -4 40 40"
      xmlns="http://www.w3.org/2000/svg"
    >
      {props.title ? (
        <title id={props.ariaTags.labelledBy} lang="en">
          {props.title}
        </title>
      ) : null}
      <g fill="none" fillRule="evenodd">
        <path
          className={theme.fill}
          d="M4.26173333 3.43730638L5.6664 1.72043404h20.8226667l1.6306666 1.71687234H4.26173333zM16.1990667 24.8959021L6.6564 15.4540936h6.0726667v-3.4330851h6.9406666v3.4330851h6.0733334l-9.544 9.4418085zM31.0177333 3.83239149l-2.412-2.88431915c-.4686666-.5837234-1.18-.94451064-1.996-.94451064H5.7884c-.816 0-1.52666667.36078724-2.01266667.94451064L1.38106667 3.83239149C.8784 4.41545532.5824 5.1884766.5824 6.01228511V27.4708809c0 1.8883617 1.562 3.4337446 3.47133333 3.4337446H28.3457333c1.908 0 3.47-1.5453829 3.47-3.4337446V6.01228511c0-.82380851-.2946666-1.59682979-.798-2.17989362z"
        />
      </g>
    </svg>
  )
}

ArchiveSolid.propTypes = {
  ariaTags: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  svg: PropTypes.string.isRequired,
  theme: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  className: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
}
